// extracted by mini-css-extract-plugin
module.exports = {"optionLabel":"CheckboxGrid_optionLabel__3x_2b","optionText":"CheckboxGrid_optionText__ZizVc","ieGroup":"CheckboxGrid_ieGroup__LFUqL","ieOption":"CheckboxGrid_ieOption__d-SaT"};